import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

const LocationSelector = ({ onChange, value, locations = [] }) => {
  const { t } = useTranslation()

  const handleChange = e => {
    onChange(e.target.value)
  }

  return (
    <div>
      <ComboBox
        value={value}
        label={t('Ubicación de origen')}
        fullWidth
        handleChange={handleChange}
        menuItems={locations.map(location => ({ label: location.internal_name, value: location.id }))}
        placeholder={t('Todas')}
      />
    </div>
  )
}

export default LocationSelector
